export const feedbackText = {
   style: "How much did you liked the style of instructor.",
   preparation: "How well prepared was the instructor before class.",
   punctuality: "How punctual was your instructor for class."
}